import { createApp } from "vue";
import type { App as VueApp } from "vue";
import { VueReCaptcha } from "vue-recaptcha-v3";

import App from "./App.vue";
import pinia from "@/plugins/pinia.ts";
import router from "@/router/index.ts";
import vuetify, { vPhoneInput } from "@/plugins/vuetify/config.ts";
import i18n from "@/plugins/i18n/config.ts";
import { appConfig } from "@/types/appConfig.type.ts";

import "./assets/style.css";

import initializeSentry from "@/plugins/sentry.ts";
import initializeInterceptor from "@/services/utils/interceptor.ts";

const app: VueApp<Element> = createApp(App);

app.use(pinia);
app.use(router);
app.use(vPhoneInput);
app.use(vuetify);
app.use(i18n);
app.use(VueReCaptcha, { siteKey: appConfig.VITE_CAPTCHA, loaderOptions: {} });

initializeSentry(app, router);
initializeInterceptor();

app.mount("#app");
